export const profileTexts = {
  et: {
    title: "Uuenda profiili",
    firstName: "Eesnimi",
    lastName: "Perekonnanimi",
    country: "Riik",
    province: "Maakond",
    municipality: "Omavalitsus",
    settlement: "Asula",
    street: "Tänav",
    house: "Maja",
    apartment: "Korter",
    postalCode: "Postiindeks",
    phone: "Telefon",
    email: "E-post",
    institution: "Kool, õpetaja või muu asutus",
    languagePlaceholder: "Keel",
    languageEt: "Eesti",
    languageEn: "Inglise",
    save: "Salvesta profiil",
    autofill: "Täida andmed poe kontolt",
    autofillNone: "Selle kontoga pole poe profiili seotud.",
    autofillDone: "Andmed täidetud — kontrolli üle ja salvesta.",
    autofillError: "Täitmine ebaõnnestus, proovi uuesti.",
    errors: {
      required: "See väli on kohustuslik.",
      invalidEmail: "Vigane e-posti aadress.",
      invalidPhone: "Vigane telefoninumber.",
    },
  },
  en: {
    title: "Update Profile",
    firstName: "First Name",
    lastName: "Last Name",
    country: "Country",
    province: "Province",
    municipality: "Municipality",
    settlement: "Settlement",
    street: "Street",
    house: "House",
    apartment: "Apartment",
    postalCode: "Postal code",
    phone: "Phone",
    email: "Email",
    institution: "School, teacher or related institution",
    languagePlaceholder: "Language",
    languageEt: "Estonian",
    languageEn: "English",
    save: "Save Profile",
    autofill: "Fill from shop account",
    autofillNone: "No shop profile is linked to this account.",
    autofillDone: "Fields filled — review and save.",
    autofillError: "Autofill failed, please try again.",
    errors: {
      required: "This field is required.",
      invalidEmail: "Invalid email address.",
      invalidPhone: "Invalid phone number.",
    },
  },
};
